import { WorkspaceRole } from '~api/workspaces/getWorkspaceMembers';
import { roleMeetsFloor } from '~api/workspaces/roleMeetsFloor';
import { WorkspaceMemberRoleFloor } from '~api/workspaces/types';

/**
 * Returns `true` if the user's workspace role is at or above the given
 * role-floor threshold. Returns `false` when role is `undefined` (still
 * loading).
 *
 * Thin wrapper over the shared `roleMeetsFloor` — the Viewer < Editor < Admin
 * < Owner ladder lives there so it can't drift between the two call sites; this
 * only adds the loading (`undefined`) guard the hook consumers need.
 */
export function meetsRoleFloor(
  userRole: WorkspaceRole | undefined,
  floor: WorkspaceMemberRoleFloor
): boolean {
  if (userRole === undefined) return false;
  return roleMeetsFloor(userRole, floor);
}
